"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasCryptoSegment = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasCryptoSegment = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.has_crypto_segment.label',
    fallbackLabel: 'Please specify if you intend to offer Klarna\'s payment services to any merchant operating in the cryptocurrency services segment.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
